import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const ShippingAddressesActionTypes = {
  CREATE_NEW_SHIPPING_ADDRESS: createSubtypes('shippingAddresses|createNewShippingAddress'),
  FETCH_SHIPPING_ADDRESSES: createSubtypes('shippingAddresses|fetchShippingAddresses'),
  UPDATE_SHIPPING_ADDRESS: createSubtypes('shippingAddresses|updateShippingAddress'),
  DELETE_SHIPPING_ADDRESS: createSubtypes('shippingAddresses|deleteShippingAddress'),
};
